import { Injectable } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';

import * as SuggestionsActions from './suggestions.actions';
import * as SuggestionsFeature from './suggestions.reducer';
import * as SuggestionsSelectors from './suggestions.selectors';

@Injectable()
export class SuggestionsFacade {
  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  loaded$ = this.store.pipe(select(SuggestionsSelectors.getSuggestionsLoaded));
  error$ = this.store.pipe(select(SuggestionsSelectors.getSuggestionsError));
  allSuggestions$ = this.store.pipe(
    select(SuggestionsSelectors.getAllSuggestions),
  );
  selectedSuggestions$ = this.store.pipe(
    select(SuggestionsSelectors.getSelected),
  );

  constructor(private readonly store: Store) {}

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */
  init() {
    this.store.dispatch(SuggestionsActions.init());
  }
}
